/* eslint-disable react-hooks/exhaustive-deps */
// @ts-nocheck
/* eslint-disable no-useless-escape */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Footer from "../../Layout/Footer";
import HeroBanner from "../../Layout/HeroBanner";
import { getSignup, registerWithoutCaptcha } from "../../service/dynamicForm";
import { getParamsFromUrl } from "../../shared/utils";
import { SocialMediaChannel } from "../../shared/constants/SocialMedia";
import ThankYou from "./ThankYou";
import SurveyForm from "./survey";
import util from "../../service/util";
import { PWAEnrollmentFields } from "./constants";


const DynamicForm = () => {
  const [pwa, setPwa] = useState({});
  const [bannerImg, setBannerImg] = useState("");
  const [footerImg, setFooterImg] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  const [loader, setLoader] = useState(true);
  const [thankYouScreen, setThankYouScreen] = useState("");
  const [splashScreen, setSplashScreen] = useState("");
  const [businessInfo, setBusinessInfo] = useState({});
  const { businessHashId } = useParams();

  const setMobileFromQueryParams = () => {
    const params = new URLSearchParams(window.location.search);
    const data = {};
    // set mobile and store from query params Note!! use common customfields not specific
    if (params.has("mobile")) {
      data.mobile = params.get("mobile");
    } 
    if (params.has("store")) {
      data.registeredStore = params.get("store");
    }
    return data;
  };

  useEffect(() => {
    if (isSubmit) {
      const timer = setTimeout(() => {
        const baseUrl = window.location.href.substring(
          0,
          window.location.href.indexOf("sign")
        );
        window.location.replace(`${baseUrl}customer-verify/${businessHashId}`);
      }, 3000);
      return () => clearInterval(timer);
    }
  }, [isSubmit]);

  useEffect(() => {
    getSignup(businessHashId).then(
      ({ config = {}, token = "", businessInfo = {} }) => {
        setBusinessInfo(businessInfo);
        setBannerImg(config?.modules?.FOR_ALL_PAGE?.headerImage);
        setFooterImg(config?.modules?.FOR_ALL_PAGE?.footerImage);
        setSplashScreen(config?.splashScreen?.background);
        setThankYouScreen(config?.thankYouScreen?.background);
        setTimeout(() => {
          setLoader(false);
        }, 2000);
        setPwa(setMobileFromQueryParams());
      }
    );
  }, [businessHashId]);

  const getSocialMediaParams = () => {
    const socialMediaParams = getParamsFromUrl(window.location.search, [
      "userId",
      "channel",
    ]);
    return Object.values(SocialMediaChannel).includes(socialMediaParams.channel)
      ? socialMediaParams
      : {};
  };

  function getStoreInURL() {
    const urlParams = new URLSearchParams(new URL(window.location.href).search);
    const STORE_KEY = "store";
    if (!urlParams.has(STORE_KEY)) {
      return "";
    }

    const storeValue = urlParams.get(STORE_KEY);
    const decodedStoreValue = decodeURIComponent(storeValue);
    return decodedStoreValue;
  }
  
 

  const getUpsertData = (rawData) => {
    const data = Object.keys(rawData)
      .filter((key) => PWAEnrollmentFields.includes(key))
      .reduce((obj, key) => {
        obj[key] = rawData[key];
        return obj;
      }, {});
    const baseData = {
      ...util.nestCustomFields(data),
      customerName: data.name,
      customerMobile: data.mobile,
      dob: util.formatDateToISO(data.dob),
      anniversary: util.formatDateToISO(data.anniversary),
      registeredStore: getStoreInURL(),
    };

    const processedCustomFields = util.processCustomBusinessDateFields(
      baseData.customBusinessFields
    );

    const dataWithCustomFields = {
      ...baseData,
      customBusinessFields: processedCustomFields,
    };

    const socialMediaParams = getSocialMediaParams();

    return {
      data: {
        ...dataWithCustomFields,
        ...socialMediaParams,
      },
      tenant: businessInfo?.tenant,
    };
  };

  const handleSubmit = (data) => {
    const upsertData = getUpsertData(data);
    const registerData = {
      tenant: businessInfo?.tenant,
      mobile: data.mobile,
      businessUnitId: businessInfo?.businessUnitId,
      data: upsertData.data || {},
    };
    register(registerData, setIsSubmit)
  };

  function register(registerData, setIsSubmit) {
    registerWithoutCaptcha(registerData).then((res) => {
      if (res.status === 200) {
        window.location.replace(res.data.redirectUrl);
        // setIsSubmit(true)
      }
    });
  }

  return (
    <>
      {splashScreen && loader && (
        <div>
          <img
            src={splashScreen}
            alt=""
            style={{ width: "100%", height: "100vh" }}
          />
        </div>
      )}
      {isSubmit === false && loader === false && (
        <>
          <HeroBanner src={bannerImg} />
          <SurveyForm onCompleting={handleSubmit} initialValues={pwa} />
          <Footer img={footerImg} />
        </>
      )}

      {isSubmit && thankYouScreen && (
        <ThankYou thankYouScreen={thankYouScreen} />
      )}
    </>
  );
};

export default DynamicForm;
